import { useTheme } from '@mui/material';
import { FunctionComponent } from 'react';
import CircleBadge from '../../../../../shared/badges/CircleBadge';

const UpdatesWarning: FunctionComponent = () => {
  const theme = useTheme();

  return <CircleBadge backgroundColor={theme.palette.error.main} />;
};

export default UpdatesWarning;
